import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";
import {
    Lock,
    ArrowLeft
} from "lucide-react";
import {
    Link,
    useNavigate,
    useSearchParams
} from "react-router-dom";
import { toast } from "react-toastify";
import { resetPassword } from "../service/authApi";
import "../styles/ResetPasswordPage.css";

const ResetPasswordPage = () => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");

    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] =
        useState(false);

    const [showConfirmPassword, setShowConfirmPassword] =
        useState(false);

    const [formData, setFormData] = useState({

        newPassword: "",

        confirmPassword: ""

    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        setFormData({

            ...formData,

            [e.target.name]: e.target.value

        });

    };

    const handleSubmit = async (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (!token) {

            toast.error("Invalid reset link.");

            return;

        }

        if (!formData.newPassword.trim()) {

            toast.error("New Password is required");

            return;

        }

        if (
            formData.newPassword !==
            formData.confirmPassword
        ) {

            toast.error("Passwords do not match");

            return;

        }

        try {

            setLoading(true);

            const response =
                await resetPassword(
                    token,
                    formData.newPassword
                );

            toast.success(response);

            navigate("/login");

        }
        catch (error: any) {

            toast.error(

                error.response?.data?.message ||

                "Unable to reset password."

            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <div className="reset-page">

            <Container>

                <Row className="justify-content-center align-items-center min-vh-92">

                    <Col xl="5" lg="6" md="8" sm="10" xs="12">

                        <Card className="reset-card shadow-lg border-0">

                            <CardBody className="p-5">

                                <div className="text-center mb-4">

                                    <div className="reset-icon">
                                        <Lock size={34} />
                                    </div>

                                    <h2 className="page-title">
                                        Reset Password
                                    </h2>

                                    <p className="page-subtitle">
                                        Create a strong new password to secure your account.
                                    </p>

                                </div>

                                <Form onSubmit={handleSubmit}>

                                    <FormGroup floating>

                                       

                                        <Input

                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }

                                            name="newPassword"
placeholder=""
                                            value={formData.newPassword}

                                            onChange={handleChange}

                                        />
 <Label>

                                            New Password

                                        </Label>
                                    </FormGroup>

                                    <FormGroup floating>

                                      
                                        <Input

                                            type={
                                                showConfirmPassword
                                                    ? "text"
                                                    : "password"
                                            }
placeholder=""

                                            name="confirmPassword"

                                            value={formData.confirmPassword}

                                            onChange={handleChange}

                                        />
  <Label>

                                            Confirm Password

                                        </Label>

                                    </FormGroup>



                                    <FormGroup check className="mb-4">

                                        <Input
                                            type="checkbox"
                                            onChange={() => {
                                                setShowPassword(!showPassword);
                                                setShowConfirmPassword(!showConfirmPassword);
                                            }}
                                        />

                                        <Label check>
                                            Show Passwords
                                        </Label>

                                    </FormGroup>

                                    <Button

                                        color="primary"

                                        className="w-100"

                                        disabled={loading}

                                    >

                                        {

                                            loading ? (
                                                <>
                                                    <Spinner
                                                        size="sm"
                                                        className="me-2"
                                                    />
                                                    Resetting...
                                                </>
                                            ) : (
                                                "Reset Password"
                                            )

                                        }

                                    </Button>

                                </Form>

                                <div className="text-center mt-4">

                                    <Link
                                        to="/login"
                                        className="back-login"
                                    >

                                        <ArrowLeft size={18} />

                                        Back to Login

                                    </Link>

                                </div>

                            </CardBody>

                        </Card>

                    </Col>

                </Row>

            </Container>

        </div>

    );

};

export default ResetPasswordPage;